import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import applicationComander from "../../../store/commanders/application.comander";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import {
  faCircleUser,
  faLongArrowAltLeft,
} from "@fortawesome/free-solid-svg-icons";

import {
  Box,
  Button,
  Group,
  Space,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { URL_PATHS } from "../../../consts/url.paths.consts";
import { Icon } from "@fortawesome/fontawesome-svg-core";
import { useTranslation } from "react-i18next";

const ActivateAccountPage = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  
  const [userName, setUserName ] = useState(null)
  const [password, setPassword ] = useState(null)

  const onSubmit = (data) =>
    applicationComander.cmd_verify(userName, data.code, password);

  const form = useForm({
    initialValues: {
      code: "",
    },
  });

  useEffect(() => {
      if (props.location?.state?.userName) {
        setUserName(props.location.state.userName);
      }
  }, [props.location?.state?.userName]);

  useEffect(() => {
      if (props.location?.state?.password) {
        setPassword(props.location.state.password);
      }
  }, [props.location?.state?.password]);

  return (
    <div>
      <div className="auth-container-box">
        <Box className="auth-single-form">
          <FontAwesomeIcon
            icon={faCircleUser as Icon}
            size={"5x"}
            className="auth-icon"
          />
          <Text className="auth-title">{t("auth.activate.title")}</Text>
          <Text className="auth-description">
            {t("auth.activate.description")}
          </Text>
          <form
            onSubmit={form.onSubmit((values) => onSubmit(values))}
            className="u-w-100"
          >
            <TextInput
              required
              autoComplete="one-time-code"
              label={t("auth.activate.code")}
              placeholder={t("auth.activate.codePlaceholder")}
              className="u-w-100"
              {...form.getInputProps("code")}
            />
            <Text
              component="button"
              type="button"
              size="sm"
              align="right"
              className="auth-link resend-code-link mt-1"
              style={{ marginTop: '1px' }}
              onClick={() => applicationComander.cmd_resend_code(userName)}
            >
              {t("auth.activate.resend")}
            </Text>

            <Group mt="lg" mb="sm">
              <Button size="lg" type="submit" className="u-w-100 auth-submit-button">
                {t("auth.activate.submit")}
              </Button>
              <Button 
                size="lg" 
                variant="outline" 
                className="u-w-100 mobile-auth-button"
                onClick={() => history.push(URL_PATHS.LOGIN)}
              >
                {t("auth.backToLogin")}
              </Button>
            </Group>

            <Text
              component="button"
              type="button"
              size="sm"
              align="left"
              className="auth-link"
              onClick={() => history.push(URL_PATHS.LOGIN)}
            >
              <FontAwesomeIcon icon={faLongArrowAltLeft as Icon} /> {t("auth.backToLogin")}
            </Text>
          </form>
        </Box>
      </div>
    </div>
  );
};

export default ActivateAccountPage;
